import React, { useEffect, useRef, useState } from 'react';
import { Parallax } from "react-scroll-parallax";
import './main.css';
import AppearingElement from "../Helper/AppearingElement";
import CTAButton from "../Helper/CTAButton";

// Landing Pages Section 2C
function DiamondInfoSection(props) {
    const [playing, setPlaying] = useState(false);
    const [showCTA, setShowCTA] = useState(false);
    const videoRef = useRef();

    useEffect(() => {
        const video = videoRef.current;
        video.currentTime = 1;
    });

    const handlePlay = () => {
        setPlaying(true);
        setShowCTA(false);
    }

    const handleEnd = () => {
        setPlaying(false);
        setShowCTA(true);
    }

    return (
        <section className="diamond-info-section playing">
            <div className="diamond-info-section__video-container">
                <Parallax x={[10, -5]} className="diamond-info-section__video">
                    <video src={props.video} ref={videoRef} preload="auto" controls playsInline onPlay={handlePlay} onEnded={handleEnd}>
                        Sorry, your browser doesn't support embedded videos.
                    </video>
                    {showCTA &&
                        <div className="diamond-info-section__video__cta">
                            <CTAButton className="ziplyne-button--gradient" size="large" variant="contained">
                                Request a Demo
                        </CTAButton>
                        </div>
                    }
                </Parallax>
            </div>
            <AppearingElement variant={'zoom-up'}>
                <div className="diamond-info-section__diamond-image">
                    <div className="diamond-info-section__diamond-image__text">
                        {props.content}
                    </div>
                </div>
            </AppearingElement>
        </section>
    );
}

export default DiamondInfoSection;